import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-drug-categories',
  templateUrl: './drug-categories.component.html',
  styleUrls: ['./drug-categories.component.css']
})
export class DrugCategoriesComponent implements OnInit {

  constructor(private api : ApiService) { }
  public updater : any;
  public title : string;

  ngOnInit() {
    if(this.selectedItem)
      this.updater();
  }

  get items(){
    return this.api.session.drugs;
  }
  get selectedItem(){
    return this.api.session.currentCriteria.drugs.selectedCategory;
  }
  set selectedItem(value){
    console.log("selectedItem setter: " + JSON.stringify(value));
    MyUtility.scrubChildren(value);
    this.api.session.currentCriteria.drugs.selectedItems = [];
    this.api.session.currentCriteria.drugs.selectedCategory = value;
    this.updater();
  }
  
  clearCurrent(){
    this.api.session.currentCriteria.drugs = MyUtility.deepCopy(this.api.originalCriteria.drugs);
    this.updater();
  }
}
